export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10038.fc15bb4e.jpg";